export const jobKeys = {
  all: ['jobs'] as const,
  detail: (jobId: string) => [...jobKeys.all, 'detail', jobId] as const,
  candidates: (jobId: string) => [...jobKeys.detail(jobId), 'candidates'] as const,
  candidateOvertime: (jobId: string, candidateId: string) =>
    [...jobKeys.detail(jobId), 'candidate-overtime', candidateId] as const,
};
